import { FormattedMessage } from 'react-intl';

import { Box, Typography } from '@mui/material';

export const CalculatorDisclaimer = () => {
  return (
    <Box px={{ xs: 3, md: 5 }} py={{ xs: 1, md: 2 }}>
      <Typography variant="body2" color="gray.500">
        <FormattedMessage
          id="calculator-disclaimer"
          defaultMessage={`This Calculator is for illustrative purposes only and has been prepared without taking account of your objectives,
            financial situation or needs. You should consider the Assumptions and Qualifications to understand how the calculator works and
            how the results can differ from actual investment returns. Past performance does not guarantee future performance.`}
        />
      </Typography>
    </Box>
  );
};
